import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import {
  CONTACT_EMAIL,
  CONTACT_PHONE_TEL,
  CONTACT_PHONE_DISPLAY,
  CONTACT_FACEBOOK_URL
} from '../config/contact';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const copyright = t('footer.copyright').replace('{year}', String(new Date().getFullYear()));

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footer.products')}</h3>
            <ul>
              <li>
                <Link to="/products?category=hazelnuts">{t('footer.hazelnuts')}</Link>
              </li>
              <li>
                <Link to="/products?category=truffles">{t('footer.truffles')}</Link>
              </li>
              <li>
                <Link to="/products?category=snacks">{t('footer.snacks')}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>{t('footer.info')}</h3>
            <ul>
              <li>
                <Link to="/contact">{t('footer.contact')}</Link>
              </li>
              <li>
                <Link to="/about">{t('footer.about')}</Link>
              </li>
              <li>
                <Link to="/terms">{t('footer.terms')}</Link>
              </li>
              <li>
                <Link to="/privacy">{t('footer.privacy')}</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-section--contact">
            <h3>{t('footer.contactTitle')}</h3>
            <ul>
              <li>
                <p className="footer-seller">{t('footer.sellerName')}</p>
                <p className="footer-delivery">{t('footer.sellerSubtitle')}</p>
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </li>
              <li>
                <a href={`tel:${CONTACT_PHONE_TEL}`}>{CONTACT_PHONE_DISPLAY}</a>
              </li>
              <li>
                <p className="footer-delivery">{t('footer.addressLine1')}</p>
                <p className="footer-delivery">{t('footer.addressLine2')}</p>
              </li>
              <li>
                <a
                  href={CONTACT_FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="footer-facebook"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{copyright}</p>
          <p className="footer-rating">{t('footer.tagline')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
